import { render, staticRenderFns } from "./BoxImportarLote.vue?vue&type=template&id=ee2f7848&scoped=true&"
import script from "./BoxImportarLote.vue?vue&type=script&lang=js&"
export * from "./BoxImportarLote.vue?vue&type=script&lang=js&"
import style0 from "./BoxImportarLote.vue?vue&type=style&index=0&id=ee2f7848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2f7848",
  null
  
)

export default component.exports